module.exports = __webpack_public_path__ + "static/comingsoon-288f161d2d84742411fab66d76c9d120.png";